/**
 * Client-side mirror of AddEditForm.php's normalizeDomain() — strips
 * protocol, www, port, path, query and trailing slash, lowercases the
 * result. Server re-normalises independently; this only exists so the
 * field can show the normalised value and confirmation copy live, per
 * README "Normalise silently as the user types."
 */
import isFQDN from "validator/lib/isFQDN";

export function normalizeDomain(raw) {
  let value = (raw || "").trim();
  value = value.replace(/^[a-z][a-z0-9+.-]*:\/\//i, "");
  value = value.replace(/^www\./i, "");
  value = value.replace(/[/?#].*$/, "");
  value = value.replace(/:\d+$/, "");
  return value.toLowerCase();
}

export const isWildcardDomain = (value) => value.includes("*");

export const isValidDomain = (value) => !!value && isFQDN(value);
